import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { blue } from '@mui/material/colors';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {  Box } from '@mui/material';
import { getAllTermCourses } from '../../services/termCourseService';
import { getCurrentTerm } from '../../services/termService';
const theme = createTheme({
  palette: {
    common: {
      black: '#7451f8', // Changing the black color to blue
    },
  },
});

const StyledTableCell = styled(TableCell)(({theme})  => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));





export default function CustomizedTables() {
  const [tableData, setTableData] = useState([]);
  const [term, setTerm] = useState(null);
const fetchTermCourse = async (id) => {
  try {
      const response = await getAllTermCourses(id);
     // console.log(response.data)
      setTableData(response.data); // Set course details from API response
  } catch (error) {
      console.error('Error fetching course:', error);
  }
};

const fetchTerm = async () => {
  try {
      const data = await getCurrentTerm();
     // console.log(data);
      setTerm(data.data);
  } catch (err) {
      
  } 
};
useEffect(() => {      

  fetchTerm();
  
  
}, []);
useEffect(() => {      
if(term && term.id){
  fetchTermCourse(term.id);
  
}
  
  
}, [term]);
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ maxHeight: 200, overflowY: 'auto' }}>
    <TableContainer component={Paper}>
      <Table size="small" sx={{ minWidth: 670}} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Course Name </StyledTableCell>
            <StyledTableCell align="right">Registered Students</StyledTableCell>
            <StyledTableCell align="right">Student Batch</StyledTableCell>
            <StyledTableCell align="right">Instructors</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData.map((row) => (
            <StyledTableRow key={row.id}>
              <StyledTableCell component="th" scope="row">
                {row.course_name}
              </StyledTableCell>
              <StyledTableCell align="right">{row.students}</StyledTableCell>
              <StyledTableCell align="right">{row.student_batch}</StyledTableCell>
              <StyledTableCell align="right">{row.instructor_names}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </Box>
    </ThemeProvider>
  );
}